import { useTranslation } from "react-i18next";
import {
  SaveOutlined,
  SearchOutlined
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Layout,
  Modal,
  Row,
  TableColumnsType,
  TableProps,
  Tabs,
  TabsProps,
  Typography,
  message
} from "antd";
import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exportFailAccountStudentExcelFile, getListStudentImportExcelFile } from "../../../service/list-account-student/listAccountStudent";
import { formatDateV2 } from "../../../utils/converDate";
import FormInput from "../../form-input/FormInput";
import TableData from "../../table-data/TableData";
import "./list-student-accounts-import.scss";

type Props = {
  handleClose: () => void
  saveAccount: () => void;
  loadingApprove?: boolean;
  open: boolean
  importMode: boolean
};

const ListStudentsAccountImportModal = (props: Props) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("1");
  const { handleClose, open, importMode, saveAccount, loadingApprove } = props;
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [listAdminInterface, setListAdminInterface] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [clearRowkey, setClearRowkey] = useState<boolean>(false);
  const [importModeExcel, setImportModeExcel] = useState<boolean>(false)

  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [countReviewed, setCountReviewed] = useState<number>(0);
  const [countAwaitingReview, setCountAwaitingReview] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("")
  const [lastPreview, setlastPreview] = useState<any>(null);
  const [filterData, setFilterData] = useState<any>({
    status: null,
    approvedDate: null,
  });

  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();


  const getListData = async () => {
    setLoading(true);
    const data = {
      page: pageNumber,
      size: pageSize,
      sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
      keyword: searchValue.trim() || undefined,
      status: tab === "1" ? true : false,
    };
    if (importModeExcel) {
      await exportFailAccountStudentExcelFile(data).then((res) => {
        if (res.status === 200) {
          const fileData = res.data
          const blob = new Blob([fileData], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);

          downloadLink.download = "Danh sách tài khoản sinh viên fail.xlsx";

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          message.success(t("Tải xuống thành công!", "Tải xuống thành công!"))
        }
      })
    } else {
      await getListStudentImportExcelFile(data)
        .then((res) => {
          const { data } = res.data
          setListAdminInterface(data.data)
          setTotalRecords(data.total);
          setCountAwaitingReview(data?.validCount)
          setCountReviewed(data?.countInvalidCount)

          setTimeout(() => {
            setLoading(false);
          }, 500);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
    setImportModeExcel(false)
  };
  useEffect(() => {
    if (location.state?.tab) {
      setTab(location.state?.tab);
    }
  }, [navigate]);

  // useEffect(() => {
  //   getListData();
  // }, [tab, pageNumber, pageSize, statusOrder, lastPreview]);

  useEffect(() => {
    if (open) {
      getListData();
    }
  }, [open, tab, pageNumber, pageSize, statusOrder, lastPreview]);

  // useEffect(() => {
  //   if (importMode) {
  //     getListData();
  //   }
  // }, [importMode, open]);

  const handleSubmitSearch = () => {
    getListData();
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      getListData();
    }
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  const dataColumns: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Email đăng nhập", "Email đăng nhập"),
      dataIndex: "username",
      key: "username",
      sorter: true,
      width: 30,
    },
    {
      title: t("Họ và tên", "Họ và tên"),
      dataIndex: "fullName",
      key: "fullName",
      width: 30,
    },
    {
      title: t("Giới tính", "Giới tính"),
      dataIndex: "gender",
      key: "gender",
      width: 20,
    },
    {
      title: t("Ngày sinh", "Ngày sinh"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record) => {
        return (
          <>{record?.birthday ? formatDateV2(record?.birthday) : null}</>
        );
      },
    },
    {
      title: t("Số giấy tờ cá nhân", "Số giấy tờ cá nhân"),
      dataIndex: "cardId",
      key: "cardId",
      width: 30,
    },
    {
      title: t("Mã sinh viên", "Mã sinh viên"),
      dataIndex: "code",
      key: "code",
      width: 30,
    },
    {
      title: t("Ngày nhập học", "Ngày nhập học"),
      dataIndex: "name",
      key: "name",
      width: 30,
      render: (_: any, record) => {
        return (
          <>{record?.admissionDate ? formatDateV2(record?.admissionDate) : null}</>
        );
      },
    },
    {
      title: t("Lớp niên khóa", "Lớp niên khóa"),
      dataIndex: "classSemester",
      key: "classSemester",
      width: 30,
    },
    {
      title: t("Mô tả", "Mô tả"),
      dataIndex: "description",
      key: "description",
      width: 30,
    },
  ];

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
          ? "desc"
          : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  const itemsTab: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <div>
          {t("Tài khoản hợp lệ", "Tài khoản hợp lệ")}
          <span
            className={`number-record ${tab === "1" ? "number-record-active" : "number-record-disabled"
              }`}
          >
            {countAwaitingReview}
          </span>
        </div>
      ),
      children: (
        <TableData
          dataColumns={dataColumns}
          loadingTable={loading}
          dataTable={listAdminInterface}
          pageSize={pageSize}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          totalRecords={totalRecords}
          scroll={{ x: 1500, y: 500 }}
          pagination={true}
          hideSelection={false}
          handleTableChangeProps={handleTableChange}
          setSelectedRowKeysProps={setSelectedRowKeys}
          clearRowkey={clearRowkey}
        />
      ),
    },
    {
      key: "2",
      label: (
        <div>
          {t("Tài khoản không hợp lệ", "Tài khoản không hợp lệ")}
          <span
            className={`number-record ${tab === "2" ? "number-record-active" : "number-record-disabled"
              }`}
          >
            {countReviewed}
          </span>
        </div>
      ),
      children: (
        <TableData
          dataColumns={dataColumns}
          loadingTable={loading}
          dataTable={listAdminInterface}
          pageSize={pageSize}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          totalRecords={totalRecords}
          scroll={{ x: 1500, y: 500 }}
          pagination={true}
          hideSelection={false}
          handleTableChangeProps={handleTableChange}
          setSelectedRowKeysProps={setSelectedRowKeys}
          clearRowkey={clearRowkey}
        />
      ),
    },
  ];

  const listBreadcrumb = [
    {
      title: t("Quản trị cơ sở", "Quản trị cơ sở"),
    },
  ];

  const onChange = (key: string) => {
    setTab(key);
    setFilterData({});
    setPageNumber(1);
    form.resetFields();
  };
  const handleCloseModal = () => {
    setTab("1");
    setSearchValue("");
    setListAdminInterface([]);
    setPageNumber(1);
    setPageSize(10);
    setTotalRecords(0);
    setCountReviewed(0);
    setCountAwaitingReview(0);
    setLoading(false);
    setSelectedRowKeys([]);
    setClearRowkey(true);
    setStatusOrder("");
    setFieldSortOrder("");
    setlastPreview(null);
    setFilterData({});
    form.resetFields();
    handleClose();
  };
  const operations = tab === "2" ? <p className="text-blue-600 cursor-pointer" onClick={() => setImportModeExcel(true)}>{t("Kết xuất tài khoản không hợp lệ", "Kết xuất tài khoản không hợp lệ")}</p> : null;

  return (
    <Modal
      title={
        <div className="flex algin-center justify-between mr-6">
          <div>{t("Danh sách File tài khoản sinh viên", "Danh sách File tài khoản sinh viên")}</div>
          <div className="flex gap-16">
            <Row className="page-header-group--layout">
              <Col md={{ span: 7 }} lg={{ span: 7 }} xl={{ span: 7 }} xs={{ span: 7 }}>
                <div className="heading-search">
                  <FormInput placeholder={t("Nhập từ khóa tìm kiếm...", "Nhập từ khóa tìm kiếm...")} value={searchValue}
                    onChange={handleChangeInput}
                    onKeyPress={handleSearch}
                    style={{ minWidth: "240px" }}
                    afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />} />
                </div>
              </Col>
            </Row>
            <Button loading={loadingApprove} className="btn btn-primary" onClick={saveAccount}>
              <SaveOutlined />
              <Typography.Text>{t("Lưu tài khoản hợp lệ", "Lưu tài khoản hợp lệ")}</Typography.Text>
            </Button>
          </div>
        </div>
      }
      className="list-student-accounts-import"
      open={open}
      onCancel={handleCloseModal}
      width={"90%"}
      centered
      style={{ height: "90vh" }}
      footer={
        <div></div>
      }
    >
      <Layout className="page-header-group course-evaluation">
        <Form.Provider
          onFormFinish={(name, { values, forms }) => {
            if (name === "filterForm") {
              getListData()
            }
          }}
        >
          <div className="tabs-heading pt-3">
            <Tabs items={itemsTab} activeKey={tab} onChange={onChange} tabBarExtraContent={operations} />
          </div>
        </Form.Provider>

      </Layout>
    </Modal>
  );
};

export default ListStudentsAccountImportModal;